export default {
    mvpIntro: 'The MVP of this session is ~',
    buttons: {
        show: 'Show',
    },
};
